module.exports = __webpack_public_path__ + "media/images/icon__point--lost@3x-96982ab1c546d18c8755744537dc99c5.png";